import ajax from '@/utils/request'

// 企业列表
export const companyList = data => ajax('/api/company/get/list', data, 'POST')
// 添加企业
export const companyAdd = data => ajax('/api/company/add', data, 'POST')
// 企业详情
export const companyDetail = data => ajax('/api/company/get/', data, 'GET')
// 企业锁定/解锁
export const companyLock = data => ajax('/api/company/lock', data, 'POST')
export const companyUnlock = data => ajax('/api/company/unlock', data, 'POST')
// 更新企业基础配置
export const companyUpdate = data => ajax('/api/company/updateBaseConfig', data, 'POST')
// 获取企业基础配置
export const companyGet = data => ajax('/api/company/getBaseConfig', data, 'GET')
